import { ContaForm } from "core/features/conta/typings";
import { Control } from "react-hook-form";
import Field from "ui/components/Input/Field";
import { getOptionsTipoDocumento } from "../util/helper";
import SelectBase from "./SelectBase";

const FieldTipoDocumento = ({ control }: { control: Control<ContaForm> }) => (
  <Field
    control={control}
    name="tipoDocumentoId"
    shouldUnregister
    label="Tipo"
    render={({ field, isInvalid }) => (
      <SelectBase
        isInvalid={isInvalid}
        onChange={field.onChange}
        value={field.value}
        options={getOptionsTipoDocumento()}
      />
    )}
  />
);

export default FieldTipoDocumento;
